"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLogsAPI = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var UserLogsAPI = /*#__PURE__*/function () {
  function UserLogsAPI() {
    (0, _classCallCheck2.default)(this, UserLogsAPI);
    this.request = null;
    this.requestParameters = null;
    this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, process.env.VUE_APP_CUSTOMER_KEY_HASH);
  }

  (0, _createClass2.default)(UserLogsAPI, [{
    key: "getLogs",
    value: function getLogs(_ref) {
      var requestParameters = _ref.requestParameters;

      var params = _objectSpread(_objectSpread({}, this.requestParameters), requestParameters);

      return this.request.get('AI_LOGS', 'user', params);
    }
  }, {
    key: "insertLogs",
    value: function insertLogs(_ref2) {
      var payload = _ref2.payload;
      return this.request.post('AI_LOGS', 'user', this.requestParameters, payload);
    }
  }]);
  return UserLogsAPI;
}();

exports.UserLogsAPI = UserLogsAPI;